<template>
  <div class="export-data">
    <button-export
      :title="title"
      :btnClass="{
        'button-export--open': $refs.popover ? $refs.popover.show : false,
      }"
      :iconShare="$refs.popover ? !$refs.popover.show : true"
      @click="toggle = !toggle"
    />
    <Popover :toggle="toggle" ref="popover">
      <ul class="export-data--list" :class="{ 'list-item-badge': !canExport }">
        <li
          @click="$emit('export', 'csv')"
          class="export-data--list--item"
          v-if="hasCsv"
        >
          <b>{{ labels.exportCsv }}</b>
          <span
            v-if="!canExport"
            class="badge-enterprise badge-danger badge-default"
            >{{ labels.enterpriseBadge }}</span
          >
        </li>
        <li
          v-if="hasPptx"
          @click="$emit('export', 'pptx')"
          class="export-data--list--item"
        >
          <b>{{ labels.exportPptx }}</b>
          <span
            v-if="!canExport"
            class="badge-enterprise badge-danger badge-default"
            >{{ labels.enterpriseBadge }}</span
          >
        </li>
        <li
          v-if="hasXlsx"
          @click="$emit('export', 'xlsx')"
          class="export-data--list--item"
        >
          <b>{{ labels.exportXslx }}</b>
          <span
            v-if="!canExport"
            class="badge-enterprise badge-danger badge-default"
            >{{ labels.enterpriseBadge }}</span
          >
        </li>
      </ul>
    </Popover>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Popover from '@/components/Shared/Popover.vue'
import ButtonExport from '@/components/Shared/ButtonExport.vue'

export default {
  components: {
    Popover,
    ButtonExport,
  },
  props: {
    canExport: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    hasCsv: {
      type: Boolean,
      default: true,
    },
    hasXlsx: {
      type: Boolean,
      default: false,
    },
    hasPptx: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toggle: false,
    }
  },
  computed: {
    ...mapGetters(['resources']),
    labels() {
      return this.resources.component.reports.exportData
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/breakpoints';

/deep/ .button-export--open {
  z-index: 1000 !important;
}

.export-data {
  /deep/ .tc-popover-body {
    margin: 0;
  }

  /deep/ &--list {
    list-style: none;
    padding: 5px 0;
    margin: 0;
    width: 100%;

    @include media-breakpoint-up(md) {
      width: 168px;

      &.list-item-badge {
        width: 250px;
      }
    }

    &--item {
      color: map-get($theme-colors, 'primary');
      cursor: pointer;
      padding: 8px 24px;

      &:hover {
        background-color: map-get($theme-colors, 'gray08');
      }

      &:not(:last-of-type) {
        border-bottom: 1px solid map-get($theme-colors, 'gray01');
      }
    }
  }
}

.footer-wrap {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
}

/deep/ .icon-tune:before {
  display: flex;
}

.apply-button {
  width: 50%;
  max-width: 200px;
}

/deep/ .tc-popover {
  padding: 0;
}
</style>
